<template>
  <div>
    <h3 class="text-xl font-bold text-neutral-900">{{ $t('Embeds') }}</h3>
    <p class="text-neutral-600 mt-1">{{ $t('You can display your boards, roadmap and updates directly on your website using embeds.') }}</p>

    <h4 class="font-semibold text-neutral-900 mt-6">{{ $t('How does it work?') }}</h4>
    <p class="text-neutral-600 mt-1">{{ $t("Before you proceed keep in mind that you will need to use a bit of HTML and CSS, if you are not familiar with these, we'd recommend finding a web developer to better assist you with the code implementation.") }}</p>
    <p class="text-neutral-600 mt-2">{{ $t('Find the code that corresponds to the page you want to incorporate into your website below, copy it and then paste it into your website, in the area you want the page to be displayed.') }}</p>

    <h4 class="mt-8 font-semibold text-neutral-900">{{ $t('Board embed') }}</h4>

    <div class="relative" id="select-div" style="width: 90%">
      <select
        id="cars"
        class="input select"
        style="height: 45px; width: 90%;"
        v-model="selectedBoard"
        ref="boardSelect"
      >
      <option v-for="board in project.boards"> {{board.name}}</option>
      </select>
    </div>

    <div class="flex flex-wrap mt-2">
      <div class="w-full">
        <div class="">
          <div class="pb-5 pt-2 flex-auto">
            <div class=" sso-webhook-style">
              <div>
                <prism-editor class="prism-code-editor rounded" v-model="code1" :line-numbers="lineNumbers" :highlight="highlighter" readonly></prism-editor>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h4 class="mt-6 font-semibold text-neutral-900">{{ $t('Roadmap embed') }}</h4>
    <div class="flex flex-wrap">
      <div class="w-full">
        <div class="">
          <div class="pb-5 pt-2 flex-auto">
            <div class=" sso-webhook-style">
              <div>
                <prism-editor class="prism-code-editor rounded" v-model="code2" :line-numbers="lineNumbers" :highlight="highlighter" readonly></prism-editor>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h4 class="mt-6 font-semibold text-neutral-900">{{ $t('Updates embed') }}</h4>
    <div class="flex flex-wrap">
      <div class="w-full">
        <div class="">
          <div class="pb-5 pt-2 flex-auto">
            <div class=" sso-webhook-style">
              <div>
                <prism-editor class="prism-code-editor rounded" v-model="code3" :line-numbers="lineNumbers" :highlight="highlighter" readonly></prism-editor>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h4 class="font-semibold text-neutral-900 mt-8">{{ $t('How do I customize the embeds?') }}</h4>
    <p class="text-neutral-600 mt-1">{{ $t('All embeds include an "embed" class in the') }} <code>&#x3C;body&#x3E;</code> {{ $t('tag, allowing you to easily apply Custom CSS to the content of the embeds when they are displayed on your website.') }}</p>
    <p class="text-neutral-600 mt-2">{{ $t("Changing the background color of your Roadmap page can be achieved by adding the following piece of code to your Project's Custom CSS area:") }}</p>
    <div class="flex flex-wrap">
      <div class="w-full">
        <div class="">
          <div class="pb-5 pt-2 flex-auto">
            <div class=" sso-webhook-style">
              <div>
                <prism-editor class="prism-code-editor rounded" v-model="code4" :line-numbers="lineNumbers" :highlight="highlighter" readonly></prism-editor>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'highlight.js/styles/github.css';
import 'vue-prism-editor/dist/prismeditor.min.css';
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css";
export default {
  props: ["project","projectDomain"],
  data() {
    return {
      code: '',
      lineNumbers: true,
      selectedBoard: this.project.boards[0].slug,
      url: this.projectDomain + "/boards/"  ,
    }
  },
  mounted() {
    this.$refs.boardSelect.selectedIndex = 0;
  },
  computed: {
    code1() {
      return this.code = `<iframe src="https://${this.url + this.selectedBoard}?embed=true" width="100%" height="300"></iframe>`
    },
    code2() {
      return this.code = `<iframe src="https://feedback.feedbear.com/roadmap?embed=true" width="100%" height="300"></iframe>`
    },
    code3() {
      return this.code = `<iframe src="https://feedback.feedbear.com/updates?embed=true" width="100%" height="300"></iframe>`
    },
    code4() {
      return this.code = `body.embed {
  background-color: grey !important;
}`;
    },
  },
  methods:{
    highlighter(code) {
      return highlight(code, languages.js);
    },
  }
};
</script>

<style scoped lang="scss">
// select {
//   height: 40px;
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   border-radius: 6px;
//   border: 1px solid #DDDDDD;
//   font-style: normal;
//   font-weight: 400;
//   font-size: 14px;
//   line-height: 120%;
//   color: #666666;
//   flex: none;
//   order: 0;
//   flex-grow: 1;
//   background: linear-gradient(180deg, #FFFFFF 0%, #EFEFEF 100%);
//   margin-top: 20px;
// }

</style>
